export default {
  theme: 'conversion',
  widgetConfig: {
    dateRange: {
      from: '',
      to: ''
    },
    viewType: 'date_range',
    periodType: 'month',
    intervalType: '7',
    filters: {}
  }
};
